module.exports = __webpack_public_path__ + "img/maisonjaune.528a514d.webp";